<template>
    <div class="footer">
        <div class="scheduled">
            <el-row :gutter="12">
                <el-col :span="8"><img src="../../static/footer/scheduled.png"/></el-col>
                <el-col :span="8"><h3>货物跟踪就找物流源</h3></el-col>
                <el-col :span="8"><el-button @click="mark()">预约演示</el-button></el-col>
            </el-row>
        </div>
        <div class="footerContent">
            <div class="footerNav">
                快速导航
            </div>
            <span class="footer-line">
            </span>
            <div class="contact">
                <div class="information">
                    <div class="hotline">
                        <img class="hotlineImg" src="../../static/footer/hotline.png" alt="热线电话">
                        <span>免费客服热线：
                            <span class="hotLineNum">4008-539-529</span>
                        </span>
                        <img class="league" src="../../static/footer/league.png" alt="诚信联盟"></img>
                    </div>
                    <div class="jumpTo">
                        <img class="logo" @click="external('homepage')" src="../../static/footer/logo.png" alt="logo"></img>
                        <ul class="ulOne">
                            <li ><a href="javascript:;" class="jumpToItem" @click="external('Visual')">解决方案</a></li>
                        </ul>
                        <ul class="ulTwo">
                            <li ><a href="javascript:;" class="jumpToItem" @click="external('FMCG')">行业案例</a></li>
                        </ul>
                        <ul class="ulThree">
                            <li ><a href="javascript:;" class="jumpToItem" @click="external('support')">服务与支持</a></li>
                        </ul>
                        <ul class="ulFour">
                            <li ><a href="javascript:;" class="jumpToItem" @click="external('aboutUsUs')">关于我们</a></li>
                        </ul>
                    </div>
                </div>
                <div class="QRCode">
                    <div class="QR-container">
                        <img src="../../static/footer/QRCode.png" alt="热线电话">
                    </div>
                </div>
            </div>
            <div class="copyright">
                <span>
                    Copyright©2005 上海南软信息科技有限公司版权所有 <a href="https://beian.miit.gov.cn" style="color: #ffffff;">沪ICP备15052516号-5</a>
                </span>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name:"footer-content",
    data() {
        return{

        }
    },
    methods: {
        external (url) {
            window.open(this.$store.state.url + '/#/'+url, '_self');
        },
        mark () {
            window.open('https://jinshuju.net/f/M6hUEl', '_blank');
        }
    }
}
</script>
<style lang="scss">
    .footer {
        ul {
            list-style: none;
            margin: 0;
            padding: 0;  
        }
    }
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue